import type { DigitalEventAsset, DigitalEventEdge, EbookAsset, EbookEdge, StudyAsset, StudyEdge } from "./types"

/**
 * `libraryV2` narrows which edges come back but not the union type of `asset`, so
 * every list has to discriminate on `__typename` before rendering. Mirrors
 * `isStudyEdge` in apps/mobile/src/features/study/components/library/StudyLibrary.tsx.
 */
export const isStudyEdge = (edge: StudyEdge): edge is StudyEdge & { node: { asset: StudyAsset } } =>
  edge.node.asset.__typename === "Study"

export const isEbookEdge = (edge: EbookEdge): edge is EbookEdge & { node: { asset: EbookAsset } } =>
  edge.node.asset.__typename === "Ebook"

/**
 * DIGITAL_EVENT returns both event kinds in one connection, so this is the only
 * list where two union members are wanted.
 */
export const isDigitalEventEdge = (
  edge: DigitalEventEdge,
): edge is DigitalEventEdge & { node: { asset: DigitalEventAsset } } =>
  edge.node.asset.__typename === "SimulcastEvent" || edge.node.asset.__typename === "OnDemandEvent"
